<template>
  <div
    :class="[
      'hilo-table-container',
      variation === 'courseContent' ? 'course-content-container' : '',
      // variation === 'unstyled' ? 'unstyled-table-container' : ''
    ]"
  >
    <table
      :class="[
        'hilo-table',
        variation === 'courseContent' ? 'course-content-table' : '',
        // variation === 'unstyled' ? 'unstyled-table' : ''
      ]"
    >
      <thead>
        <tr>
          <th
            v-for="column in filteredColumns"
            :key="column.key"
            @click="variation !== 'courseContent' && variation !== 'unstyled' && sortBy(column.key)"
            :style="variation !== 'unstyled' ? {
              backgroundColor: variation === 'courseContent' ? '#a148ad' : column.backgroundColor || 'lightgrey',
              color: variation === 'courseContent' ? '#ffffff' : '#000000'
            } : {}"
            :class="{
              'sorted-asc': sortKey === column.key && sortOrder === 'asc' && variation !== 'unstyled',
              'sorted-desc': sortKey === column.key && sortOrder === 'desc' && variation !== 'unstyled'
            }"
          >
            {{ column.label }}
            <span v-if="sortKey === column.key">
              {{ sortOrder === "asc" ? "▲" : "▼" }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, index) in sortedData"
          :key="index"
          :class="[
            rowClass ? rowClass(row) : '',
            variation === 'courseContent' ? 'course-content-row' : '',
          ]"
        >
          <td
            v-for="column in filteredColumns"
            :key="column.key"
            :class="{
              'left-align-cell':
                variation === 'courseContent' &&
                (column.key === 'type' || column.key === 'lessonTitle'),
            }"
            :style="variation !== 'unstyled' ? (
            variation === 'courseContent' ? { border: '1px solid #cccccc' } : {}
          ) : {}"
          >
            <div v-if="column.component">
              <span v-if="column.componentProps(row).title">
                {{ column.componentProps(row).title }}
              </span>
              <br v-if="column.componentProps(row).title" />
              <component
                v-if="column.component && column.component !== 'select'"
                :is="column.component"
                v-bind="column.componentProps ? column.componentProps(row) : {}"
                @click="
                  column.componentProps
                    ? column.componentProps(row).onClick?.(row)
                    : null
                "
              />
            </div>
            <select
              v-else-if="column.component === 'select'"
              v-model="row[column.key]"
              @change="(e) => (row[column.key] = e.target.value)"
              v-select-min-width="column.componentProps(row).options"
            >
              <option
                v-for="option in column.componentProps(row).options"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </option>
            </select>
            <span
              v-else-if="column.isHtml"
              v-html="
                column.format ? column.format(row[column.key]) : row[column.key]
              "
            ></span>
            <span
              v-else
              :style="
                column.key === 'grade'
                  ? { color: getGradeColor(row.grade), fontWeight: 'bold' }
                  : column.key === 'tracking'
                    ? {
                        color: getTrackingColor(row.tracking),
                        fontWeight: 'bold',
                      }
                    : {}
              "
              >{{
                column.format ? column.format(row[column.key]) : row[column.key]
              }}</span
            >
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="newLessonBtn"
      v-if="variation === 'courseContent'"
      @click="openCreateLesson"
    >
      <img
        class="circlePlusIcon"
        alt=""
        src="/static/img/grey-circle-plus.svg"
      />
      New Lesson
    </div>
  </div>
</template>

<script>
import HiloButton from "./HiloButton.vue";
import {
  getGradeColor,
  getTrackingColor,
} from "@/util/gradesAndTrackingColors";

export default {
  components: {
    HiloButton,
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    rowClass: {
      type: Function,
      default: null,
    },
    variation: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      sortKey: "",
      sortOrder: "asc",
    };
  },
  computed: {
    filteredColumns() {
      return this.columns.filter((column) => {
        if (typeof column.condition === "function") {
          return column.condition();
        }
        return true;
      });
    },
    sortedData() {
      if (!this.sortKey) return this.data;

      return [...this.data].sort((a, b) => {
        let aValue = this.getNestedValue(a, this.sortKey);
        let bValue = this.getNestedValue(b, this.sortKey);

        if (typeof aValue === "string" && aValue.startsWith("$")) {
          aValue = parseFloat(aValue.replace(/[^0-9.-]+/g, ""));
        }
        if (typeof bValue === "string" && bValue.startsWith("$")) {
          bValue = parseFloat(bValue.replace(/[^0-9.-]+/g, ""));
        }

        if (!isNaN(parseFloat(aValue)) && !isNaN(parseFloat(bValue))) {
          aValue = parseFloat(aValue);
          bValue = parseFloat(bValue);
        }

        if (aValue === bValue) return 0;

        if (this.sortOrder === "asc") {
          return aValue > bValue ? 1 : -1;
        } else {
          return aValue < bValue ? 1 : -1;
        }
      });
    },

  },
  methods: {
    getTrackingColor,
    getGradeColor,
    getNestedValue(obj, key) {
      return key.split(".").reduce((o, i) => (o ? o[i] : null), obj);
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }
    },
    openCreateLesson() {
      this.$emit("createNewLesson");
    },
  },
  directives: {
    selectMinWidth: {
      inserted(el, binding) {
        const options = binding.value;
        const tempDiv = document.createElement("div");
        tempDiv.style.position = "absolute";
        tempDiv.style.visibility = "hidden";
        tempDiv.style.height = "auto";
        tempDiv.style.width = "auto";
        tempDiv.style.whiteSpace = "nowrap";
        document.body.appendChild(tempDiv);

        let maxWidth = 0;
        options.forEach((option) => {
          tempDiv.textContent = option;
          const width = tempDiv.clientWidth;
          if (width > maxWidth) {
            maxWidth = width;
          }
        });

        document.body.removeChild(tempDiv);
        el.style.minWidth = `${maxWidth + 40}px`;
      },
    },
  },
};
</script>

<style>
.newLessonBtn {
  font-size: 14px;
  color: #a0a0a0;
  cursor: pointer;
}
.circlePlusIcon {
  width: 15px;
  position: relative;
  height: 15px;
  overflow: hidden;
  flex-shrink: 0;
  margin-left: 15px;
  margin-right: 5px;
}
.hilo-table-container {
  overflow-x: auto;
  width: 100%;
}

.hilo-table {
  width: 100%;
  border-collapse: collapse;
}

.hilo-table th,
.hilo-table td {
  text-align: center;
  padding: 8px;
  font-size: 14px;
  white-space: nowrap;
  border-left: 1px solid #f4f4f4;
  border-right: 1px solid #f4f4f4;
}

.hilo-table th {
  background-color: #f4f4f4;
  font-weight: lighter;
  color: black;
  cursor: pointer;
}

.hilo-table td {
  border-bottom: 1px solid #f4f4f4;
}

.hilo-table select {
  appearance: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 15px;
  font-size: 14px;
  line-height: 1.2;
  color: #333;
  cursor: pointer;
  width: 80%;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 20 20"><polygon points="0,0 20,0 10,10" fill="%23333"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 10px;
}

.hilo-table select:focus {
  border-color: #2196f3;
  box-shadow: 0 0 5px rgba(33, 150, 243, 0.5);
  outline: none;
}

/*noinspection CssUnusedSymbol */
.hilo-table-container.course-content-container {
  background-color: #ffffff;
  border-radius: 15px;
}

/*noinspection CssUnusedSymbol */
.hilo-table.course-content-table {
  border: 1px solid #cccccc;
  border-collapse: separate;
  border-spacing: 0;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.hilo-table.course-content-table th:first-child {
  border-top-left-radius: 15px;
}

.hilo-table.course-content-table th:last-child {
  border-top-right-radius: 15px;
}

.hilo-table.course-content-table tr:last-of-type td {
  //border-bottom-left-radius: 15px;
  border-bottom: 1px solid #ccc !important;
}

.hilo-table.course-content-table th {
  border: 1px solid #cccccc;
}

.hilo-table.course-content-table td {
  border: 1px solid #cccccc;
}

.hilo-table.course-content-table th:first-child,
.hilo-table.course-content-table td:first-child {
  border-left: 1px solid #cccccc;
}

.hilo-table.course-content-table th:last-child,
.hilo-table.course-content-table td:last-child {
  border-right: 1px solid #cccccc;
}

/*noinspection CssUnusedSymbol */
.hilo-table.course-content-table td.left-align-cell {
  text-align: left;
  padding-left: 12px;
}

.unstyled-table-container {
  all: unset;
}

.unstyled-table {
  all: unset;
}

.unstyled-table th,
.unstyled-table td {
  all: unset;
}
</style>
